// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { LandlordDTO } from '../models';
import { UpdateLandlordDTO } from '../models';
/**
 * LandlordsApi - axios parameter creator
 * @export
 */
export const LandlordsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get a landlord by id
         * @param {string} id Landlord id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandlordById(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling getLandlordById.');
            }
            const localVarPath = `/v2/landlords/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a Landlord\'s email, Address and Organization by id
         * @param {string} id Landlord id
         * @param {UpdateLandlordDTO} updateLandlordDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLandlord(id: string, updateLandlordDTO: UpdateLandlordDTO, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling updateLandlord.');
            }
            // verify required parameter 'updateLandlordDTO' is not null or undefined
            if (updateLandlordDTO === null || updateLandlordDTO === undefined) {
                throw new RequiredError('updateLandlordDTO','Required parameter updateLandlordDTO was null or undefined when calling updateLandlord.');
            }
            const localVarPath = `/v2/landlords/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"UpdateLandlordDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(updateLandlordDTO !== undefined ? updateLandlordDTO : {}) : (updateLandlordDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LandlordsApi - functional programming interface
 * @export
 */
export const LandlordsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Get a landlord by id
         * @param {string} id Landlord id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandlordById(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandlordDTO> {
            const localVarAxiosArgs = LandlordsApiAxiosParamCreator(configuration).getLandlordById(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a Landlord\'s email, Address and Organization by id
         * @param {string} id Landlord id
         * @param {UpdateLandlordDTO} updateLandlordDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLandlord(id: string, updateLandlordDTO: UpdateLandlordDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<LandlordDTO> {
            const localVarAxiosArgs = LandlordsApiAxiosParamCreator(configuration).updateLandlord(id, updateLandlordDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * LandlordsApi - factory interface
 * @export
 */
export const LandlordsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Get a landlord by id
         * @param {string} id Landlord id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLandlordById(id: string, options?: any) {
            return LandlordsApiFp(configuration).getLandlordById(id, options)(axios, basePath);
        },
        /**
         * Update a Landlord\'s email, Address and Organization by id
         * @param {string} id Landlord id
         * @param {UpdateLandlordDTO} updateLandlordDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateLandlord(id: string, updateLandlordDTO: UpdateLandlordDTO, options?: any) {
            return LandlordsApiFp(configuration).updateLandlord(id, updateLandlordDTO, options)(axios, basePath);
        },
    };
};

/**
 * LandlordsApi - interface
 * @export
 * @interface LandlordsApi
 */
export interface LandlordsApiInterface {
    /**
     * Get a landlord by id
     * @param {string} id Landlord id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandlordsApiInterface
     */
    getLandlordById(id: string, options?: any): AxiosPromise<LandlordDTO>;

    /**
     * Update a Landlord\'s email, Address and Organization by id
     * @param {string} id Landlord id
     * @param {UpdateLandlordDTO} updateLandlordDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandlordsApiInterface
     */
    updateLandlord(id: string, updateLandlordDTO: UpdateLandlordDTO, options?: any): AxiosPromise<LandlordDTO>;

}

/**
 * LandlordsApi - object-oriented interface
 * @export
 * @class LandlordsApi
 * @extends {BaseAPI}
 */
export class LandlordsApi extends BaseAPI implements LandlordsApiInterface {
    /**
     * Get a landlord by id
     * @param {string} id Landlord id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandlordsApi
     */
    public getLandlordById(id: string, options?: any) {
        return LandlordsApiFp(this.configuration).getLandlordById(id, options)(this.axios, this.basePath);
    }

    /**
     * Update a Landlord\'s email, Address and Organization by id
     * @param {string} id Landlord id
     * @param {UpdateLandlordDTO} updateLandlordDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandlordsApi
     */
    public updateLandlord(id: string, updateLandlordDTO: UpdateLandlordDTO, options?: any) {
        return LandlordsApiFp(this.configuration).updateLandlord(id, updateLandlordDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for LandlordsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Get a landlord by id
 * @param {string} id Landlord id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function getLandlordById(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<LandlordDTO> {
    const localVarAxiosArgs = LandlordsApiAxiosParamCreator(configuration).getLandlordById(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update a Landlord\'s email, Address and Organization by id
 * @param {string} id Landlord id
 * @param {UpdateLandlordDTO} updateLandlordDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateLandlord(
    id: string,
    updateLandlordDTO: UpdateLandlordDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<LandlordDTO> {
    const localVarAxiosArgs = LandlordsApiAxiosParamCreator(configuration).updateLandlord(id, updateLandlordDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

